const DAY_MS = 1000 * 60 * 60 * 24;
export const getDifferenceDateByDay = (startDate: Date, endDate: Date) => {
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);
    return Math.floor((endDate.getTime() - startDate.getTime()) / DAY_MS);
};
